import { getApi } from "./api_instance";

export const getBankDetails = async (dispatch) => {
  try {
    return await getApi({
      apiUrl: "/api/bankAccount/user-account",
      dispatch,
      sendToken: true,
    });
  } catch (error) {
    throw error;
  }
};
